<template>
  <div class="filt" :class="{ filt_inline: inline }">
    <div class="filt__col">
      <v-select label="name" placeholder="Направление" @input="selecting_division"
                :reduce="division_list => division_list.id"
                :options="division_list"
                v-model="division_selected">
        <!-- eslint-disable-next-line vue/no-unused-vars  -->
        <template #no-options="{ search, searching, loading }">
          Нет данных
        </template>
      </v-select>
    </div>
    <div class="filt__col">
      <v-select label="name" placeholder="Услуга"
                :reduce="service_list => service_list.id"
                :options="service_list"
                v-model="service_selected">
        <!-- eslint-disable-next-line vue/no-unused-vars  -->
        <template #no-options="{ search, searching, loading }">
          Нет данных
        </template>
      </v-select>
    </div>
    <div class="filt__col">
      <v-select label="name" placeholder="Район" @input="selecting_district"
                :reduce="district_list => district_list.id"
                :options="district_list"
                v-model="district_selected">
        <!-- eslint-disable-next-line vue/no-unused-vars  -->
        <template #no-options="{ search, searching, loading }">
          Нет данных
        </template>
      </v-select>
    </div>
    <div class="filt__col">
      <v-select label="name" placeholder="Метро"
                :reduce="metro_list => metro_list.id"
                :options="metro_list"
                v-model="metro_selected">
        <!-- eslint-disable-next-line vue/no-unused-vars  -->
        <template #no-options="{ search, searching, loading }">
          Нет данных
        </template>
      </v-select>
    </div>
    <div class="filt__col">
      <v-select label="name" placeholder="Клиника"
                :reduce="clinic_list => clinic_list.id"
                :options="clinic_list"
                v-model="clinic_selected">
        <!-- eslint-disable-next-line vue/no-unused-vars  -->
        <template #no-options="{ search, searching, loading }">
          Нет данных
        </template>
      </v-select>
    </div>
    <div class="filt__col">
      <el-button type="danger" class="btn-filter" @click="onSubmit"
      >Найти
      </el-button>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import axios from "axios";

const queryString = require("query-string");

export default {
  props: {
    inline: Boolean,
    service: {
      type: Number,
      required: false
    },
    division: {
      type: Number,
      required: false
    },
    district: {
      type: Number,
      required: false
    },
    metro: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      params: {
        division_selected: "",
        service_selected: "",
        district_selected: "",
        metro_selected: "",
        clinic_selected: ""
      },
      division_list: [],
      division_selected: "",
      service_list: [],
      service_selected: "",
      district_list: [],
      district_selected: "",
      metro_list: [],
      metro_selected: "",
      clinic_list: [],
      clinic_selected: "",
      windowWidth: window.innerWidth
    };
  },
  methods: {
    selecting_division(val) {
      if (val) {
        this.cleanServices();
        this.getServices(val);
      } else {
        this.getServices();
      }
    },
    selecting_district(val) {
      if (val) {
        this.cleanMetro();
        this.getMetro(val);
      } else {
        this.getMetro();
      }
    },
    cleanMetro() {
      this.metro_list = [];
      this.metro_selected = "";
    },
    cleanServices() {
      this.service_list = [];
      this.service_selected = "";
    },
    getDistricts() {
      api.get("/districts/").then(response => {
        this.district_list = response.data;
      });
    },
    getMetro(district = false) {
      let params = {};
      if (district) {
        params["district"] = district;
      }
      api.get("/metro/", {params}).then(response => {
        this.metro_list = response.data;
      });
    },
    getDivisions() {
      api.get("/divisions/").then(response => {
        this.division_list = response.data;
      });
    },
    getServices(division = false) {
      let params = {};
      if (division) {
        params["division"] = division;
      }
      api.get("/services/", {params}).then(response => {
        this.service_list = response.data;
      });
    },
    initialData() {
      axios
        .all([
          api.get("/divisions/"),
          api.get(
            "/services/",
            this.params.division
              ? {params: {division: this.params.division}}
              : ""
          ),
          api.get("/districts/"),
          api.get(
            "/metro/",
            this.params.district
              ? {params: {district: this.params.district}}
              : ""
          ),
          api.get("/all_clinics/")
        ])
        .then(
          axios.spread((divisions, services, districts, metro, clinics) => {
            this.division_list = divisions.data;
            this.service_list = services.data;
            this.district_list = districts.data;
            this.metro_list = metro.data;
            this.clinic_list = clinics.data;
            this.fetchUrlData();
          })
        );
    },
    fetchUrlData() {
      let that = this;
      let isExistsDivision = that.division_list.some(function (el) {
        return el.id === that.params.division;
      });
      that.division_selected = isExistsDivision ? that.params.division : "";

      let isExistsService = that.service_list.some(function (el) {
        return el.id === that.params.service;
      });
      that.service_selected = isExistsService ? that.params.service : "";

      let isExistsDistrict = that.district_list.some(function (el) {
        return el.id === that.params.district;
      });
      that.district_selected = isExistsDistrict ? that.params.district : "";

      let isExistsClinic = that.clinic_list.some(function (el) {
        return el.id === that.params.clinic;
      });
      that.clinic_selected = isExistsClinic ? that.params.clinic : "";

      let isExistsMetro = that.metro_list.some(function (el) {
        return el.id === that.params.metro;
      });
      that.metro_selected = isExistsMetro ? that.params.metro : "";
    },
    initialByUrlParams() {
      const parsed = queryString.parse(location.search);
      this.params.division = parseInt(parsed.division) || "";
      this.params.service = parseInt(parsed.service) || "";
      this.params.district = parseInt(parsed.district) || "";
      this.params.metro = parseInt(parsed.metro) || "";
      this.params.clinic = parseInt(parsed.clinic) || "";

      if (this.service){
        this.params.service = this.service;
      }
      if (this.division){
        this.params.division = this.division;
      }
      if (this.district){
        this.params.district = this.district;
      }
      if (this.metro){
        this.params.metro = this.metro;
      }

    },
    onSubmit() {
      let payload = {
        division: this.division_selected,
        service: this.service_selected,
        district: this.district_selected,
        metro: this.metro_selected,
        clinic: this.clinic_selected
      };
      window.location.href = "/clinics/?" + queryString.stringify(payload);
    }
  },
  created: function () {
    this.initialByUrlParams();
    this.initialData();
  }
};
</script>

<style scoped lang="scss">

.filt {
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  &__col {
    flex: 1 1 auto;
    margin: 5px;
  }
}


@media (min-width: 1024px) {
  .filt {
    flex-direction: row;
    flex-wrap: wrap;

    &__col {
      width: 30%;
    }
  }
}

@media (min-width: 1200px) {
  .filt__col {
    width: calc((100% / 6) - 20px);
  }
}


.filt.filt_inline {
  flex-wrap: wrap;
  flex-direction: column;

  .filt__col {
    width: 100%;
  }
}


.btn-filter {
  padding: 11px 32px !important;
  font-size: 16px !important;
  width: 100%;
}

.el-select {
  display: block !important;
  max-width: 600px;
}

.el-select-dropdown {
  max-width: 98% !important;
}

@media (max-width: 768px) {
  .el-form--inline .el-form-item {
    display: block !important;
  }
}
</style>
